import { PvForecastingConfig } from '@core/models';
import { PvForecastingService } from '@core/services';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { inject } from '@angular/core';
import { pipe, switchMap, tap } from 'rxjs';

type PvForecastingState = {
  isLoading: boolean;
  config: PvForecastingConfig | undefined;
};

const initialState: PvForecastingState = {
  isLoading: false,
  config: undefined,
};

export const PvForecastingStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, pvForecastingService = inject(PvForecastingService)) => ({
    // Loads the config for a device. A 404 (no config yet) is the normal
    // "not configured" state and resolves to `config: undefined`.
    getConfigMethod: rxMethod<number>(
      pipe(
        tap(() => patchState(store, { isLoading: true, config: undefined })),
        switchMap(deviceId =>
          pvForecastingService.getDeviceConfig(deviceId).pipe(
            tapResponse({
              next: (config: PvForecastingConfig) =>
                patchState(store, { config, isLoading: false }),
              error: () => patchState(store, { config: undefined, isLoading: false }),
            }),
          ),
        ),
      ),
    ),

    // Writes go through PvForecastingService directly (so callers get
    // success/error callbacks); this keeps the cached config in sync.
    setConfig(config: PvForecastingConfig | undefined): void {
      patchState(store, { config });
    },
  })),
);
